"use strict";

exports.__esModule = true;
exports.createParser = createParser;

var _responsive = require("./responsive");

var _lodash = _interopRequireDefault(require("lodash.get"));

var _lodash2 = _interopRequireDefault(require("lodash.merge"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function sort(obj) {
  var next = {};
  Object.keys(obj).sort(function (a, b) {
    return a.localeCompare(b, undefined, {
      numeric: true,
      sensitivity: 'base'
    });
  }).forEach(function (key) {
    next[key] = obj[key];
  });
  return next;
}

function createParser(config) {
  var cache = new Map();

  var parser = function parser(props) {
    var styles = {};
    var shouldSort = false;
    var isCacheDisabled = (props == null ? void 0 : props.theme) && props.theme.disableStyledSystemCache;

    for (var prop in props) {
      if (!config[prop]) continue;
      var systemConfig = config[prop];
      var scale = (0, _lodash["default"])(props.theme, systemConfig.scale, systemConfig.defaultScale);
      var propValue = props[prop];
      if (propValue === undefined) return {};

      if (typeof propValue === 'function') {
        propValue = propValue(props.theme);
      }

      if (typeof propValue === 'object') {
        var breakpoints = !isCacheDisabled && cache.get('breakpoints') || (0, _lodash["default"])(props.theme, 'breakpoints', _responsive.defaultBreakpoints);
        cache.set('breakpoints', breakpoints);

        if (Array.isArray(propValue)) {
          var mediaQueries = !isCacheDisabled && cache.get('mediaQueries') || [null].concat((0, _responsive.parseBreakpoints)(breakpoints));
          cache.set('mediaQueries', mediaQueries);
          var responsiveStyles = (0, _responsive.parseResponsiveStyle)({
            cache: cache,
            propValue: propValue,
            props: props,
            scale: scale,
            systemConfig: systemConfig
          });
          styles = (0, _lodash2["default"])(styles, responsiveStyles);
          continue;
        }

        if (propValue !== null) {
          shouldSort = true;

          var _responsiveStyles = (0, _responsive.parseResponsiveObject)({
            cache: cache,
            propValue: propValue,
            props: props,
            scale: scale,
            systemConfig: systemConfig
          });

          styles = (0, _lodash2["default"])(styles, _responsiveStyles);
          continue;
        }
      }

      styles = _extends({}, styles, systemConfig(propValue, scale, props));
    }

    if (shouldSort) {
      styles = sort(styles);
    }

    return styles;
  };

  parser.config = config;
  parser.propNames = Object.keys(config);
  parser.cache = cache;
  var keys = Object.keys(config).filter(function (k) {
    return !['config', 'propNames', 'cache'].includes(k);
  });

  if (keys.length > 1) {
    keys.forEach(function (key) {
      var _createParser, _Object$assign;

      Object.assign(parser, (_Object$assign = {}, _Object$assign[key] = createParser((_createParser = {}, _createParser[key] = config[key], _createParser)), _Object$assign));
    });
  }

  return parser;
}